module.exports = __webpack_public_path__ + "img/wish.15335bb.svg";